import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Book = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Book' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M10,1 L10,11 L13,9 L16,11 L16,1 M5.5,18 C4.11928813,18 3,19.1192881 3,20.5 C3,21.8807119 4.11928813,23 5.5,23 L22,23 M3,20.5 L3,3.5 C3,2.11928813 4.11928813,1 5.5,1 L21,1 L21,18.0073514 L5.49217286,18.0073514 M20.5,18 C19.1192881,18 18,19.1192881 18,20.5 C18,21.8807119 19.1192881,23 20.5,23 L20.5,23' />
  </StyledIcon>
);
